import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { t } from '../../services/i18nService';
import styles from './livesession.scss';
import audioSinkService from '../../services/livesession/AudioSinkService';
import proctorCallSelector from '../../selectors/livesession/ProctorCallSelector';

export class ProctorCall extends React.PureComponent {
    static propTypes = {
        proctorId: PropTypes.string.isRequired,

        // resolved
        remoteAudioStream: PropTypes.object,
        remoteWebcamStream: PropTypes.object,
        shouldShowProctor: PropTypes.bool.isRequired,
        shouldShowReconnecting: PropTypes.bool.isRequired,
        speakerDeviceId: PropTypes.string.isRequired,
    };

    setRemoteAudioRef = (element) => {
        const { remoteAudioStream } = this.props;
        this.remoteAudio = element;

        if (this.remoteAudio) {
            this.remoteAudio.srcObject = remoteAudioStream;
        }
    };

    setRemoteWebcamRef = (element) => {
        const { remoteWebcamStream } = this.props;
        this.remoteWebcam = element;

        if (this.remoteWebcam) {
            this.remoteWebcam.srcObject = remoteWebcamStream;
        }
    };

    /**
     * The audio output device setting must be applied on audio element only
     * after the media resource has finished loading.
     */
    setSinkId = async (loadEvent) => {
        await audioSinkService.setSinkId(
            loadEvent.target,
            this.props.speakerDeviceId,
        );
    };

    render() {
        const {
            proctorId,
            shouldShowProctor,
            shouldShowReconnecting,
        } = this.props;

        const callClass = [styles.cameraContainer];
        if (!shouldShowProctor) {
            callClass.push(styles.hideProctorCall);
        }

        return (
            <div className={callClass.join(' ')} id={`proctorCall_${proctorId}`}>
                { shouldShowProctor &&
                    // eslint-disable-next-line jsx-a11y/media-has-caption
                    <video
                        className={styles.remoteWebcam}
                        ref={this.setRemoteWebcamRef}
                        autoPlay
                        muted
                    />
                }

                { shouldShowReconnecting &&
                    <div className={styles.reconnectingCall}>
                        <i className="fa fa-refresh fa-spin" aria-hidden="true" />
                        {t('liveSession.stabilizingConnection')}
                    </div>
                }

                {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
                <audio
                    className={styles.remoteAudio}
                    ref={this.setRemoteAudioRef}
                    onLoadedData={this.setSinkId}
                    autoPlay
                />
            </div>
        );
    }
}

const ProctorCallContainer = connect(proctorCallSelector.mapStateToProps)(ProctorCall);
export default ProctorCallContainer;
